module.exports = __webpack_public_path__ + "img/biking-helmet-person.308f93af.svg";